import axios from 'axios'
import config from '../config'

const server = config.SERVER
const baseUrl = '/wp-json/features/v1/settings'

const getFeatureToggles = async () => {
  const response = await axios.get(`${server}${baseUrl}`)
  return response.data
}

export default {
  getFeatureToggles,
}
